<div class="modal" data-id="plc-modal" hidden>
  <div class="modal__backdrop" data-id="plc-backdrop"></div>

  <div class="modal__dialog modal__dialog--wide plc-detail" data-id="plc-dialog" role="dialog" aria-modal="true"
       aria-labelledby="plc-detail-title">
    <header class="modal__header">
      <h2 class="modal__title" id="plc-detail-title" data-id="plc-title"><%= _lcs( 'Eintrag' ) %></h2>
      <button type="button" class="iconbtn modal__close" data-id="plc-close" aria-label="<%= _lcs( 'Schließen' ) %>">
        <i class="icon icon--x"></i>
      </button>
    </header>

    <div class="modal__body">
      <p class="modal__error" data-id="plc-error" hidden></p>

      <p class="plc-detail__meta">
        <span class="plc-detail__badges" data-id="plc-badges"></span>
        <span class="plc-detail__key" data-id="plc-key">–</span>
      </p>

      <!-- Cover + gallery -->
      <div class="plc-detail__gallery" data-id="plc-images" hidden></div>

      <!-- Original text or one of its machine translations. -->
      <div class="plc-detail__langs" data-id="plc-langs"></div>

      <p class="plc-detail__teaser" data-id="plc-teaser" hidden></p>
      <div class="plc-detail__text" data-id="plc-description" hidden></div>

      <div class="plc-detail__cols">
        <section class="plc-detail__col">
          <h3 class="evs-form__legend"><%= _lcs( 'Adresse' ) %></h3>
          <dl class="plc-detail__facts" data-id="plc-address"></dl>

          <h3 class="evs-form__legend"><%= _lcs( 'Kontakt' ) %></h3>
          <dl class="plc-detail__facts" data-id="plc-contact"></dl>
        </section>

        <section class="plc-detail__col">
          <h3 class="evs-form__legend"><%= _lcs( 'Öffnungszeiten' ) %></h3>
          <dl class="plc-detail__facts" data-id="plc-hours"></dl>
          <p class="field__note" data-id="plc-hours-note" hidden></p>

          <h3 class="evs-form__legend"><%= _lcs( 'Küche & Ausstattung' ) %></h3>
          <dl class="plc-detail__facts" data-id="plc-attributes"></dl>
        </section>
      </div>

      <h3 class="evs-form__legend"><%= _lcs( 'Herkunft' ) %></h3>
      <dl class="plc-detail__facts" data-id="plc-provenance"></dl>
    </div>

    <footer class="modal__footer">
      <p class="plc-detail__hint" data-id="plc-hint"></p>
      <button type="button" class="btn btn--ghost btn--sm" data-id="plc-cancel"><%= _lcs( 'Schließen' ) %></button>
      <button type="button" class="btn btn--primary btn--sm" data-id="plc-publish">
        <span data-id="plc-publish-label"><%= _lcs( 'Veröffentlichen' ) %></span>
      </button>
    </footer>
  </div>
</div>
